import axios from "./request.js";

// AI模型配置项定义（key、默认值、说明）
export const AI_SETTING_ITEMS = [
  {
    key: "chat_model",
    defaultValue: "gpt-5.6-terra",
    label: "GRS Chat 模型",
    usage: "商品价格检查（fetchPage）页面内容分析"
  },
  {
    key: "draw_model",
    defaultValue: "nano-banana-pro",
    label: "GRS 图片生成模型",
    usage: "AI图片生成"
  },
  {
    key: "deepseek_model",
    defaultValue: "deepseek-chat",
    label: "DeepSeek 模型",
    usage: "Return/Warranty AI Auto Fill 智能识别"
  }
];

const DEFAULT_SETTINGS = AI_SETTING_ITEMS.reduce((acc, item) => {
  acc[item.key] = item.defaultValue;
  return acc;
}, {});

// 缓存（与后端AiSetting的5分钟缓存对应）
let cache = null;
let cacheTime = 0;
const CACHE_TTL = 5 * 60 * 1000;

// 将后端返回的各种可能结构归一化为 { key: value } 对象
function normalizeSettings(res) {
  const result = { ...DEFAULT_SETTINGS };
  if (!res) return result;

  let payload = res;
  // 兼容 { ret/code, data: ... } 包装
  if (
    !Array.isArray(res) &&
    typeof res === "object" &&
    res.data !== undefined &&
    (res.ret !== undefined ||
      res.code !== undefined ||
      res.message !== undefined)
  ) {
    payload = res.data;
  }

  if (Array.isArray(payload)) {
    // [{key: 'chat_model', value: 'xxx'}, ...]
    payload.forEach(item => {
      if (item && item.key && item.value !== undefined) {
        result[item.key] = String(item.value);
      }
    });
  } else if (payload && typeof payload === "object") {
    Object.keys(DEFAULT_SETTINGS).forEach(k => {
      if (
        payload[k] !== undefined &&
        payload[k] !== null &&
        payload[k] !== ""
      ) {
        result[k] = String(payload[k]);
      }
    });
  }
  return result;
}

/**
 * 获取全部AI模型设置（带5分钟缓存）
 * @param {boolean} force 强制刷新
 * @returns {Promise<{chat_model: string, draw_model: string, deepseek_model: string}>}
 */
export async function getAiSettings(force = false) {
  if (!force && cache && Date.now() - cacheTime < CACHE_TTL) {
    return { ...cache };
  }
  const res = await axios.get("ai-settings");
  cache = normalizeSettings(res);
  cacheTime = Date.now();
  return { ...cache };
}

/**
 * 获取单个模型设置
 * @param {string} key chat_model / draw_model / deepseek_model
 * @param {boolean} force
 */
export async function getAiSetting(key, force = false) {
  const settings = await getAiSettings(force);
  return settings[key] !== undefined ? settings[key] : DEFAULT_SETTINGS[key];
}

/**
 * 修改单个模型设置（仅管理员）
 * @param {string} key
 * @param {string} value
 */
export async function setAiSetting(key, value) {
  const res = await axios.post("ai-settings", { key, value });
  // 修改成功后清缓存并刷新
  cache = null;
  cacheTime = 0;
  await getAiSettings(true);
  return res;
}
